import { Z3kRoutes, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { BoilerCascade, HeatingCircuit, RadioSensor } from 'z3k-config';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
const filterRadioRelay = (array) => {
    if (array)
        return array.filter((el) => RadioSensor.isRelaySensor(el));
    return [];
};
const filterRadioSensor868 = (array) => {
    if (array)
        return array.filter((el) => !RadioSensor.isFobButtons(el) &&
            !RadioSensor.isRelaySensor(el) &&
            RadioSensor.isThermometer(el));
    return [];
};
const filterFobs = (array) => {
    if (array)
        return array.filter((el) => RadioSensor.isFobButtons(el));
    return [];
};
const filterHeatingModes = (config) => {
    const heating_circuits = HeatingCircuit.get.all(config);
    const boiler_cascades = BoilerCascade.get.all(config);
    const array = config.heating_modes;
    if (array)
        return array.filter((el) => HeatingMode.filterConsumerMode(el, heating_circuits, boiler_cascades));
    return [];
};
const filterBoilerModes = (config) => {
    const heating_circuits = HeatingCircuit.get.all(config);
    const boiler_cascades = BoilerCascade.get.all(config);
    const array = config.heating_modes;
    if (array)
        return array.filter((el) => HeatingMode.filterBoilerMode(el, heating_circuits, boiler_cascades));
    return [];
};
export const parseConfigWithRouter = (config) => {
    return {
        [Z3kRoutes.modbus_devices]: {
            [Z3kSecondRoutes.modbus_devices]: config?.modbus_devices ?? [],
        },
        [Z3kRoutes.mqtt_topics]: {
            [Z3kSecondRoutes.mqtt_topics]: config?.mqtt_topics ?? [],
        },
        [Z3kRoutes.sensors]: {
            [Z3kSecondRoutes.analog_inputs]: config?.analog_inputs ?? [],
        },
        [Z3kRoutes.guard_zones]: {
            [Z3kSecondRoutes.zone]: config?.guard_zones ?? [],
            [Z3kSecondRoutes.tm_keys]: config?.tm_keys ?? [],
        },
        [Z3kRoutes.guard_indicators]: {
            [Z3kSecondRoutes.indicator]: config?.guard_indicators ?? [],
        },
        [Z3kRoutes.buzzers]: {
            [Z3kSecondRoutes.buzzer]: config?.buzzers ?? [],
        },
        [Z3kRoutes.heating_circuits]: {
            [Z3kSecondRoutes.heating_circuit]: config?.heating_circuits ?? [],
            [Z3kSecondRoutes.boiler_groups]: config?.boiler_groups ?? [],
            [Z3kSecondRoutes.boiler_cascades]: config?.boiler_cascades ?? [],
        },
        [Z3kRoutes.heating_modes]: {
            [Z3kSecondRoutes.heating_modes]: filterHeatingModes(config),
            [Z3kSecondRoutes.boiler_modes]: filterBoilerModes(config),
        },
        [Z3kRoutes.managed_mechanisms]: {
            [Z3kSecondRoutes.pumps]: config?.pumps ?? [],
            [Z3kSecondRoutes.relay_controls]: config?.relay_controls ?? [],
            [Z3kSecondRoutes.threeway_taps]: config?.threeway_taps ?? [],
            [Z3kSecondRoutes.boiler_adapters]: config?.boiler_adapters ?? [],
            [Z3kSecondRoutes.analog_outputs]: config?.analog_outputs ?? [],
        },
        [Z3kRoutes.notifications]: {
            [Z3kSecondRoutes.notifications]: config?.notifications ?? [],
        },
        [Z3kRoutes.output_actions]: {
            [Z3kSecondRoutes.output_actions]: config?.output_actions ?? [],
        },
        [Z3kRoutes.radiomodules]: {
            [Z3kSecondRoutes.radiomodules]: config?.radiomodules ?? [],
        },
        [Z3kRoutes.radiorelays]: {
            [Z3kSecondRoutes.radiorelay]: filterRadioRelay(config?.radiosensors),
        },
        [Z3kRoutes.radiosensors]: {
            [Z3kSecondRoutes.radiosensor433]: config?.radiosensors433 ?? [],
            [Z3kSecondRoutes.radiosensor868]: filterRadioSensor868(config?.radiosensors ?? []),
        },
        [Z3kRoutes.fobs]: {
            [Z3kSecondRoutes.fob]: config?.fobs ?? [],
            [Z3kSecondRoutes.radiosensor868]: filterFobs(config?.radiosensors),
        },
        [Z3kRoutes.scenarios]: {
            [Z3kSecondRoutes.scenarios]: config?.scenarios ?? [],
        },
        [Z3kRoutes.users]: {
            [Z3kSecondRoutes.users]: config?.users ?? [],
            [Z3kSecondRoutes.user_roles]: config?.user_roles ?? [],
        },
        [Z3kRoutes.temperature_sensors]: {
            [Z3kSecondRoutes.analog_temperature_sensors]: config?.analog_temperature_sensors ?? [],
            [Z3kSecondRoutes.wired_temperature_sensors]: config?.wired_temperature_sensors ?? [],
        },
        [Z3kRoutes.web_elements]: {
            [Z3kSecondRoutes.web_elements]: config?.web_elements ?? [],
        },
        [Z3kRoutes.ui]: {
            [Z3kSecondRoutes.ui_groups]: config?.ui_groups ?? [],
        },
        [Z3kRoutes.service]: {
            [Z3kSecondRoutes.io_extensions]: config?.io_extensions ?? [],
        },
    };
};
